// extracted by mini-css-extract-plugin
export var card = "_n8-0";
export var content = "_n8-2";
export var icon = "_n8-1";